import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
  faShareFromSquare,
} from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import './MacStyleCarousel.css'

import image1 from '../../../../assets/developer/chenchen01.jpg'
import image2 from '../../../../assets/appstore/cover1.png'

const carouselData = [
  {
    title: 'Get Started',
    subtitle: 'New to Yichen Wang?',
    description: 'Welcome to my portfolio, showcasing my apps and artwork.',
    image: image1, // Add the image paths here
  },
  {
    title: 'Most Popular',
    subtitle: 'Chensites.com',
    description: 'Professional Art Class Notes Sharing',
    image: image2, // Add the image paths here
  },
]

const MacStyleCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % carouselData.length)
  }

  const prevSlide = () => {
    setCurrentIndex(
      prevIndex => (prevIndex - 1 + carouselData.length) % carouselData.length
    )
  }

  const { title, subtitle, description, image } = carouselData[currentIndex]

  return (
    <div className="carousel-container">
      <button onClick={prevSlide} className="carousel-prev">
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <div
        className="carousel-container-content"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="carousel-text">
          <div className="carousel-text-title">{title}</div>
          <div className="carousel-text-subtitle">
            {subtitle === 'Chensites.com' ? (
              <a
                href="https://Chensites.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {subtitle}{' '}
                <FontAwesomeIcon
                  icon={faShareFromSquare}
                  className="carousel-text-subtitle-icon"
                />
              </a>
            ) : (
              subtitle
            )}
          </div>
          <div className="carousel-text-info">{description}</div>
        </div>
      </div>

      <button onClick={nextSlide} className="carousel-next">
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  )
}

MacStyleCarousel.propTypes = {
  carouselData: PropTypes.array,
}

export default MacStyleCarousel
